/* This file is autogenerated, see readme.md for instructions */
import EyeCrossedSvgIcon from '@bloomreach/banana-theme/icons/eye-crossed.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const EyeCrossedIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <EyeCrossedSvgIcon />
    </Icon>
  );
});

EyeCrossedIcon.displayName = 'EyeCrossedIcon';

export default EyeCrossedIcon;
